@if (!showOnlyRouterOutLetPage) {
  <div class="col-md-12 row clear-all flow-content">
    @if (enableHeader) {
      <app-header></app-header>
    }
    <div class="container m-auto">
      <div class="top-container">
        @if (enableBreadCrumbFeature) {
          <div class="breadcrumb-container">
            <app-breadcrumb></app-breadcrumb>
          </div>
        }
        <div class="content-container">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
    @if (enableFooter) {
      <app-footer></app-footer>
    }
  </div>
}
@if (showOnlyRouterOutLetPage) {
  <div>
    <router-outlet></router-outlet>
  </div>
}